import React from "react";
import News from "./News";
import SliderModule from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slider = SliderModule.default || SliderModule;

const HomeSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    pauseOnHover: false,
    swipe: true,
    draggable: true,
    cssEase: "ease-in-out",
  };

  return (
    <section className="slider-sec">
      <div className="news">
        <News />
      </div>

      <div className="homeslider">
        <Slider {...settings}>
          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider1.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>

          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider2.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>
          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider3.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>
          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider4.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>
          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider5.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>
          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider6.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>
          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider7.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>
          <div className="slider-item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/slider8.jpeg"
              className="slider-image"
              alt="CSSK"
            />
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default HomeSlider;
